import { groupTraits, identifyTraits } from '@gonfalon/constants/constants';

const EXP_PREFIX = 'exp_';

export function getExperimentProps(source?: 'identify' | 'group'): Record<string, unknown> {
  let sources;
  if (source === 'identify') {
    sources = [identifyTraits()];
  } else if (source === 'group') {
    sources = [groupTraits()];
  } else {
    sources = [identifyTraits(), groupTraits()];
  }
  const props: Record<string, unknown> = {};
  for (const s of sources) {
    if (s) {
      for (const [k, v] of Object.entries(s)) {
        if (k.startsWith(EXP_PREFIX)) {
          props[k] = v;
        }
      }
    }
  }
  return props;
}
